var map = {
	"./drdoctor/practitioner.png": 673,
	"./freedoctor/practitioner.png": 674,
	"./freelegal/practitioner.png": 675,
	"./legalchief/practitioner.png": 676,
	"./medi4u/practitioner.png": 677
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 116;